const COMING_SOON_MODE = 'coming-soon';
const FULL_MODE = 'full';
const DEFAULT_MODE = FULL_MODE;

export function resolveSiteMode(value) {
  const normalized = String(value || '').trim().toLowerCase();
  if (normalized === COMING_SOON_MODE || normalized === FULL_MODE) {
    return normalized;
  }

  return DEFAULT_MODE;
}

export function isComingSoonSiteMode(mode) {
  return resolveSiteMode(mode) === COMING_SOON_MODE;
}

const RAW_SITE_MODE =
  typeof __CEDRUM_SITE_MODE__ === 'string'
    ? __CEDRUM_SITE_MODE__
    : import.meta?.env?.VITE_SITE_MODE;

export const SITE_MODE = resolveSiteMode(RAW_SITE_MODE);
export const IS_COMING_SOON = SITE_MODE === COMING_SOON_MODE;
